import React, { useCallback, useState, useEffect, useRef } from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import { PagersView } from './pagers-view';
import { carRepairs } from 'src/api/cars/vm-view';
import PageSection from 'src/layouts/page-section';
import { currentSeconds } from 'src/utils/date-locale';
import { registerSoftRefresh, unregisterSoftRefresh } from 'src/utils/window-reload';

const Page = ({ onNavigate, item, options }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const hasFetched = useRef(false);

  const [data, setData] = useState([]);
  const fetchData = useCallback(async (item) => {
    if (hasFetched.current) return;
    hasFetched.current = true;
   
    try {
      const result = await carRepairs(item.id, options, currentSeconds());
      setData(result);
    } catch (error) {
      
    } finally {
      hasFetched.current = false;
    }
  }, []);

  useEffect(() => {
    if(item && options){
      const refreshCallback = () => fetchData(item);

      fetchData(item);
      registerSoftRefresh(refreshCallback);

      return () => {
        unregisterSoftRefresh(refreshCallback); // Cleanup
      };
    }
  }, [item, options, fetchData]);

  return (
    <PageSection title="Car Pagers" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.carManagement)}
        />
        <PagersView item={item} options={options} services={data} />
      </Stack>
    </PageSection>
  );
};

export default Page;
